export default __webpack_public_path__ + "static/media/device_id.f445f22c.csv";